//#region IMPORT
import React, { useState, useEffect, useRef, seState } from 'react';
import TRA_BASIC_02 from './TRA_BASIC_02';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { Loading } from '../../../../Components/MUIs';
import useDelete from '../../../../hooks/useDelete';
import useActionLog from '../../../../hooks/useActionLog';
import { setAddButtonErrorTrue } from '../../../../Reducer/StatusFlagsReducer';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import { PDFDocument } from 'pdf-lib';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
  Buttonk,
  Checkbox,
  FormControlLabel,
  Button,
  FormGroup,
  Chip,
} from '@mui/material';
import {
  CloudUpload as CloudUploadIcon,
  ConnectedTvOutlined,
  DriveFolderUpload as FileUploadIcon,
  Download as DownloadIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'TrainingPage';

function TRA_BASIC_02F(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);

  //로그 관련
  const { SaveActionLog } = useActionLog();

  // 교육자료 등록 그리드
  const [rowData1, setRowData1] = useState([]); // 교육자료 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 교육자료 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 교육자료 그리드 변경 시 데이터

  // 그리드 행 별 파일 업로드팝업
  const [modalToggle1, setModalToggle1] = useState(false);

  // 추가 버튼클릭 시 파일 업로드팝업 - 부서고르는 팝업
  const [modalToggle2, setModalToggle2] = useState(false);
  const [modalRowData2, setModalRowData2] = useState([]);
  const [selectedModalRowData2, setSelectedModalRowData2] = useState([]);
  const [changedModalRowData2, setChangedModalRowData2] = useState([]);
  const [convertedPdfPath, setConvertedPdfPath] = useState(''); // 변환된 hwp파일 저장

  // 추가 버튼클릭 시 부서고르는 팝업에서 자료등록하는 모달
  const [modalToggle3, setModalToggle3] = useState(false);

  const rowClickData = useRef(null);

  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewFileName, setPreviewFileName] = useState('');

  const fileInputRef = useRef(null);
  const prevFilePathRef = useRef();
  const prevVideoPathRef = useRef('');

  const [videoFile, setVideoFile] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [videoLocation, setVideoLocation] = useState('');
  const [videoFileName, setVideoFileName] = useState('');

  const [eduFile, setEduFile] = useState(null);
  const [eduLocation, setEduLocation] = useState('');
  const [eduFileName, setEduFileName] = useState('');
  const [eduFilePath, setEduFilePath] = useState('');

  const [departmentList, setDepartmentList] = useState([]); // 전체 부서 데이터
  const [selectedBonbu, setSelectedBonbu] = useState([]);
  const [selectedBuseo, setSelectedBuseo] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [selectedPart, setSelectedPart] = useState([]);

  const [bonbuList, setBonbuList] = useState([]);
  const [buseoList, setBuseoList] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [partList, setPartList] = useState([]);

  useEffect(() => {
    const bonbuSet = new Set(
      departmentList
        .map((dep) => {
          return dep.DEP_NM1;
        })
        .filter(Boolean)
    );

    const bonbus = Array.from(bonbuSet);
    setBonbuList(bonbus);
  }, [departmentList]);

  useEffect(() => {
    if (selectedBonbu.length === 0) {
      setBuseoList([]);
      setSelectedBuseo([]);
      setTeamList([]);
      setSelectedTeam([]);
      setPartList([]);
      setSelectedPart([]);
      return;
    }

    const buseoSet = new Set(
      departmentList
        .filter((dep) => selectedBonbu.includes(dep.DEP_NM1))
        .map((dep) => dep.DEP_NM2)
        .filter(Boolean)
    );
    setBuseoList(Array.from(buseoSet));

    // 하위 초기화
    setSelectedBuseo([]);
    setTeamList([]);
    setSelectedTeam([]);
    setPartList([]);
    setSelectedPart([]);
  }, [selectedBonbu, departmentList]);

  // 부서 선택 바뀌면 팀 목록 업데이트, 하위 초기화
  useEffect(() => {
    if (selectedBuseo.length === 0) {
      setTeamList([]);
      setSelectedTeam([]);
      setPartList([]);
      setSelectedPart([]);
      return;
    }

    const teamSet = new Set(
      departmentList
        .filter((dep) => selectedBuseo.includes(dep.DEP_NM2))
        .map((dep) => dep.DEP_NM3)
        .filter(Boolean)
    );
    setTeamList(Array.from(teamSet));

    setSelectedTeam([]);
    setPartList([]);
    setSelectedPart([]);
  }, [selectedBuseo, departmentList]);

  // 팀 선택 바뀌면 파트 목록 업데이트, 하위 초기화
  useEffect(() => {
    if (selectedTeam.length === 0) {
      setPartList([]);
      setSelectedPart([]);
      return;
    }

    const partSet = new Set(
      departmentList
        .filter((dep) => selectedTeam.includes(dep.DEP_NM3))
        .map((dep) => dep.DEP_NM4)
        .filter(Boolean)
    );
    setPartList(Array.from(partSet));

    setSelectedPart([]);
  }, [selectedTeam, departmentList]);

  // 체크박스 토글 함수 (다중 선택)
  const toggleSelection = (value, selectedList, setSelectedList) => {
    if (selectedList.includes(value)) {
      const updated = selectedList.filter((v) => v !== value);
      setSelectedList(updated);
    } else {
      setSelectedList([...selectedList, value]);
    }
  };

  // 렌더링 체크박스 목록
  const renderCheckboxList = (list = [], selectedList = [], onChange) => {
    if (!Array.isArray(list) || list.length === 0) {
      return (
        <Typography variant="body2" sx={{ p: 1, color: 'gray' }}>
          선택 가능한 항목이 없습니다.
        </Typography>
      );
    }

    return list.map((item) => (
      <FormControlLabel
        key={item}
        control={
          <Checkbox
            checked={selectedList.includes(item)}
            onChange={() => onChange(item)}
          />
        }
        label={item}
      />
    ));
  };

  // 초기 데이터 불러오기
  useEffect(() => {
    fetchDepartmentData(); //부서 전체 데이터
  }, []);

  // // 본부
  // const handleBonbuChange = (bonbu) => {
  //   setSelectedBonbu(prev =>
  //     prev.includes(bonbu) ? prev.filter(b => b !== bonbu) : [...prev, bonbu]
  //   );
  // };

  // // 부서
  // const handleBuseoChange = (buseo) => {
  //   setSelectedBuseo(prev =>
  //     prev.includes(buseo) ? prev.filter(b => b !== buseo) : [...prev, buseo]
  //   );
  // };

  // // 팀
  // const handleTeamChange = (team) => {
  //   setSelectedTeam(prev =>
  //     prev.includes(team) ? prev.filter(b => b !== team) : [...prev, team]
  //   );
  // };

  // // 파트
  // const handlePartChange = (part) => {
  //   setSelectedPart(prev =>
  //     prev.includes(part) ? prev.filter(b => b !== part) : [...prev, part]
  //   );
  // };

  // 전체본부 리스트 조회
  const fetchDepartmentData = async () => {
    try {
      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TRA_BASIC_04_R3',
            _CUST_CD: Commons.EncryptAES(props.searchRef.current.custCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length === 0) {
          dispatch(
            showSnackbar({
              message: data[0]?.message || '데이터가 없습니다.',
              type: 'info',
            })
          );
        } else if (data[0]?.type === 'Error') {
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
          return false;
        } else {
          setDepartmentList(data); //전체부서 세팅
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
    }
  };

  // 본부선택 이벤트
  const handleBonbuSelect = (bonbu) => {
    setSelectedBonbu(bonbu);
    setSelectedBuseo('');
    setSelectedTeam('');
    setSelectedPart('');

    const filtered = departmentList.filter((dep) => dep.DEP_NM1 === bonbu);
    const buseoSet = new Set(filtered.map((dep) => dep.DEP_NM2));
    setBuseoList([...buseoSet]);
  };

  // 부서선택 이벤트
  const handleBuseoSelect = (buseo) => {
    setSelectedBuseo(buseo);
    setSelectedTeam('');
    setSelectedPart('');

    const filtered = departmentList.filter(
      (dep) => dep.DEP_NM1 === selectedBonbu && dep.DEP_NM2 === buseo
    );
    const teamSet = new Set(filtered.map((dep) => dep.DEP_NM3));
    setTeamList([...teamSet]);
  };

  // 팀선택 이벤트
  const handleTeamSelect = (team) => {
    setSelectedTeam(team);
    setSelectedPart('');

    const filtered = departmentList.filter(
      (dep) =>
        dep.DEP_NM1 === selectedBonbu &&
        dep.DEP_NM2 === selectedBuseo &&
        dep.DEP_NM3 === team
    );
    const partSet = new Set(filtered.map((dep) => dep.DEP_NM4));
    setPartList([...partSet]);
  };

  // 최종선택된 DEP_CD  추출
  const getExportDepCds = () => {
    const finalItems = getFilteredSelectedItems(); // Chip에 보여지는 항목
    const depCds = new Set();

    for (const item of finalItems) {
      // 어떤 DEP_NM 필드에 해당하는지 찾아서 matching
      if (departmentList.some((dep) => dep.DEP_NM4 === item)) {
        departmentList
          .filter((dep) => dep.DEP_NM4 === item)
          .forEach((dep) => depCds.add(dep.DEP_CD));
      } else if (departmentList.some((dep) => dep.DEP_NM3 === item)) {
        departmentList
          .filter((dep) => dep.DEP_NM3 === item)
          .forEach((dep) => depCds.add(dep.DEP_CD));
      } else if (departmentList.some((dep) => dep.DEP_NM2 === item)) {
        departmentList
          .filter((dep) => dep.DEP_NM2 === item)
          .forEach((dep) => depCds.add(dep.DEP_CD));
      } else if (departmentList.some((dep) => dep.DEP_NM1 === item)) {
        departmentList
          .filter((dep) => dep.DEP_NM1 === item)
          .forEach((dep) => depCds.add(dep.DEP_CD));
      }
    }

    return Array.from(depCds);
  };
  const getDepLevel = (item) => {
    if (departmentList.some((dep) => dep.DEP_NM4 === item)) return '파트';
    if (departmentList.some((dep) => dep.DEP_NM3 === item)) return '팀';
    if (departmentList.some((dep) => dep.DEP_NM2 === item)) return '부서';
    if (departmentList.some((dep) => dep.DEP_NM1 === item)) return '본부';
    return '';
  };
  // const getExportDepCds = () => {
  //   const target = departmentList.filter(dep => {
  //     if (selectedPart.length > 0) {
  //       return selectedPart.includes(dep.DEP_NM4);
  //     }
  //     if (selectedTeam.length > 0) {
  //       return selectedTeam.includes(dep.DEP_NM3);
  //     }
  //     if (selectedBuseo.length > 0) {
  //       return selectedBuseo.includes(dep.DEP_NM2);
  //     }
  //     if (selectedBonbu.length > 0) {
  //       return selectedBonbu.includes(dep.DEP_NM1);
  //     }
  //     return false;
  //   });

  //   return Array.from(new Set(target.map(dep => dep.DEP_CD)));
  // };

  // 중첩 필터링 함수
  const getFilteredSelectedItems = () => {
    const selectedItems = [];

    // Part 선택 항목은 항상 우선순위 가장 높음
    selectedPart.forEach((part) => selectedItems.push(part));

    // Team에서 Part에 포함되지 않은 것만 추가
    selectedTeam.forEach((team) => {
      const hasPart = departmentList.some(
        (dep) => dep.DEP_NM3 === team && selectedPart.includes(dep.DEP_NM4)
      );
      if (!hasPart) selectedItems.push(team);
    });

    // Buseo에서 Team이나 Part에 포함되지 않은 것만 추가
    selectedBuseo.forEach((buseo) => {
      const hasTeamOrPart = departmentList.some(
        (dep) =>
          dep.DEP_NM2 === buseo &&
          (selectedTeam.includes(dep.DEP_NM3) ||
            selectedPart.includes(dep.DEP_NM4))
      );
      if (!hasTeamOrPart) selectedItems.push(buseo);
    });

    // Bonbu에서 Buseo/Team/Part에 포함되지 않은 것만 추가
    selectedBonbu.forEach((bonbu) => {
      const hasDescendant = departmentList.some(
        (dep) =>
          dep.DEP_NM1 === bonbu &&
          (selectedBuseo.includes(dep.DEP_NM2) ||
            selectedTeam.includes(dep.DEP_NM3) ||
            selectedPart.includes(dep.DEP_NM4))
      );
      if (!hasDescendant) selectedItems.push(bonbu);
    });

    return selectedItems;
  };

  // 최종선택한 부서의 하위부서 전체 저장 로직
  const handleSave = async () => {
    const depCdList = getExportDepCds();
    if (!depCdList.length) {
      dispatch(
        showSnackbar({ message: '대상 부서를 선택해주세요.', type: 'warning' })
      );
      return;
    }
    // 로딩중 띄우기
    setLoading(true);
    dispatch(showLoading());

    try {
      // 기존 파일 경로 저장용 객체
      const existingVideoPaths = {};
      const existingEduPaths = {};

      // 저장 전에 기존 경로 가져오기
      for (const depCd of depCdList) {
        const reqData = [
          {
            procedureName: 'SP_TRA_BASIC_04_R2',
            _DEP_CD: Commons.EncryptAES(depCd),
          },
        ];

        const result = await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          reqData
        );

        const data = result?.data?.[0];
        if (data) {
          existingVideoPaths[depCd] = data.VIDEO_LOCATION || '';
          existingEduPaths[depCd] = data.EDU_LOCATION || '';
        }
      }

      for (const depCd of depCdList) {
        // 파일명 가져오기 (파일이 있으면 file.name, 없으면 상태값 사용)
        const videoName = videoFile?.name || videoFileName || '';
        const eduName = eduFile?.name || eduFileName || '';

        //DB저장용 경로(파일name포함)
        const videoPath = videoName
          ? `Video/${props.searchRef.current.custCd}/${depCd}/DEP_BASIC/${videoName}`
          : '';
        const eduPath = eduName
          ? `Education/${props.searchRef.current.custCd}/${depCd}/DEP_BASIC/${eduName}`
          : '';

        //서버저장용 경로(파일name빼고)
        const videoPathServer = `Video/${props.searchRef.current.custCd}/${depCd}/DEP_BASIC`;
        const eduPathServer = `Education/${props.searchRef.current.custCd}/${depCd}/DEP_BASIC`;

        // DB 저장 호출
        await saveToDB(depCd, videoName, videoPath, eduName, eduPath);

        // 파일서버에 동영상 업로드 (파일이 있을 때만)
        if (videoFile) {
          await SaveLogic2(
            videoPathServer,
            videoFile,
            existingVideoPaths[depCd]
          );
        }

        // 파일서버에 교육자료 업로드 (파일이 있을 때만)
        if (eduFile) {
          await SaveLogic3(eduPathServer, eduFile, existingEduPaths[depCd]);
        }
      }
      dispatch(
        showSnackbar({ message: '저장 및 업로드 완료.', type: 'success' })
      );

      setModalToggle2(false); //모달닫기

      // 정상 완료 시 로그
      await SaveActionLog([...depCdList], {
        menuId: SCREEN_MENU_ID,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'SUCCESS',
      });

      await SearchLogic1(); //그리드 재조회
    } catch (error) {
      // 오류 시 로그
      await SaveActionLog([...depCdList], {
        menuId: SCREEN_MENU_ID,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'ERROR',
        errorMsg: error.message,
      });

      console.error('저장 중 오류 발생:', error);
      dispatch(
        showSnackbar({
          message: error.message || '저장 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      // 로딩 종료
      setLoading(false);
      dispatch(closeLoading());
    }
  };

  // DB 저장
  const saveToDB = async (depCd, vName, vPath, eName, ePath) => {
    try {
      const requestData = [
        {
          procedureName: 'SP_TRA_BASIC_04_U3',
          _CUST_CD: Commons.EncryptAES(props.searchRef.current.custCd),
          _DEP_CD: Commons.EncryptAES(depCd),
          _VIDEO_LOCATION: Commons.EncryptAES(vPath || ''),
          _VIDEO_FILE_NAME: Commons.EncryptAES(vName || ''),
          _EDU_LOCATION: Commons.EncryptAES(ePath || ''),
          _EDU_FILE_NAME: Commons.EncryptAES(eName || ''),
          _USER_ID: userInfo.userid,
        },
      ];

      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        requestData
      );

      let isError = false;
      const data = result.data;

      if (Array.isArray(data)) {
        isError = data.some((item) => item.type === 'Error');
      } else if (data && data.type === 'Error') {
        isError = true;
      }

      if (isError) {
        // 배열일 경우 첫 메시지, 아니면 단일 메시지 출력
        const message = Array.isArray(data)
          ? data[0]?.message || 'DB 저장 오류'
          : data.message || 'DB 저장 오류';
        throw new Error(message);
      }

      return true;
    } catch (error) {
      console.error('saveToDB 오류:', error);
      dispatch(
        showSnackbar({
          message: error.message || 'DB 저장 실패',
          type: 'error',
        })
      );
      return false;
    }
  };

  // 그리드 행별 비디오파일 업로드 시(그리드 업로드 버튼 클릭 시 팝업)
  const handleVideoChange = async (e) => {
    const file = e.target.files[0];

    if (file && file.type.startsWith('video/')) {
      setVideoFile(file); // 비디오파일 세팅
      // 저장 로직 호출
      const videoName = file.name;
      const oldFilePath = prevVideoPathRef.current;

      // 파일서버의 기존파일 삭제
      if (oldFilePath) {
        await moveAndReplaceFile(oldFilePath, null, null, null);
      }

      saveVideoFile(videoName, file); //DB에 바로 저장
      // ✅ 최신 경로 갱신
      const newPath = `Video/${props.searchRef.current.custCd}/${rowClickData.current.DEP_CD}/DEP_BASIC/${videoName}`;
      prevVideoPathRef.current = newPath; // 경로 매번 갱신 해줘야 파일 수정 시 파일서버의 경로 찾아옴
    } else {
      alert('비디오 파일만 업로드 가능합니다.');
    }
  };

  // 전체 비디오파일 업로드 시 (추가버튼 클릭 시 팝업)
  const handleVideoChange2 = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file && file.type.startsWith('video/')) {
      setVideoFile(file); // 비디오 파일 세팅
    } else {
      alert('비디오 파일만 업로드 가능합니다.');
    }
  };

  // 그리드 행별 교육파일 업로드 시(그리드 업로드 버튼 클릭 시 팝업)
  const handleEduFileChange = async (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    try {
      const url = await uploadFileAndGetUrl(file);

      if (url) {
        setEduFile(file);
        setPreviewUrl(url);
        setPreviewFileName(file.name); // 파일명 저장
        dispatch(
          showSnackbar({
            message: `${file.name} 파일이 저장되었습니다.`,
            type: 'info',
          })
        );
      } else {
        setPreviewUrl('');
        dispatch(
          showSnackbar({
            message: `${file.name} 파일은 미리보기를 지원하지 않습니다.`,
            type: 'warning',
          })
        );
      }
    } catch (error) {
      setPreviewUrl('');
      dispatch(
        showSnackbar({
          message: `미리보기 로딩 실패: ${error.message}`,
          type: 'error',
        })
      );
    } finally {
      // 선택한 파일 초기화 (동일 파일 선택시 onChange 이벤트 발생하도록)
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  // 전체 교육파일 업로드 시(추가버튼 클릭시 팝업)
  const handleEduFileChange2 = async (e, depCd) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const { path, url } = await uploadFileAndGetUrl2(file, depCd); // <- 여기서 URL + 경로 받음

      if (url) {
        setEduFile(file); // 원본 파일 상태 저장
        setPreviewUrl(url); // 미리보기 URL
        setPreviewFileName(file.name); // 파일명

        // 파일 경로 저장
        setEduLocation(path);
        setEduFilePath(path);
        setEduFileName(file.name);

        dispatch(
          showSnackbar({
            message: `${file.name} 파일 미리보기가 로딩되었습니다.`,
            type: 'info',
          })
        );
      } else {
        setPreviewUrl('');
        dispatch(
          showSnackbar({
            message: `${file.name} 파일은 미리보기를 지원하지 않습니다.`,
            type: 'warning',
          })
        );
      }
    } catch (error) {
      setPreviewUrl('');
      dispatch(
        showSnackbar({
          message: `파일 미리보기 실패: ${error.message}`,
          type: 'error',
        })
      );
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  //#endregion

  // 팝업 오픈시 초기 파일 정보 불러오기 ( 동영상, 교육자료 )
  const loadInitialFile = async (_DEP_CD) => {
    console.log(_DEP_CD, 'loadInitialFile');
    const reqData = [
      {
        procedureName: 'SP_TRA_BASIC_04_R2',
        _DEP_CD: Commons.EncryptAES(_DEP_CD) || '',
      },
    ];

    const result = await Commons.Axios(
      'post1',
      Global.base.useUrl + Global.urls.Execute.execute,
      reqData
    );

    const data = result.data;

    if (!data || data.length === 0 || data[0]?.type === 'Error') {
      console.log(data, 'data에러러러러러러ㅓ');
      dispatch(
        showSnackbar({
          message:
            lanInfo.length === 0
              ? ''
              : lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'NotData'
                )?.LAN_NM || '',
          type: 'info',
        })
      );
      setPreviewUrl('');
      setPreviewFileName('');
      setVideoUrl(null);
      setVideoFile(null);
      return;
    }

    /** 교육 자료 처리 */
    const eduPath = data[0].EDU_LOCATION || '';
    const eduFixedUrl = eduPath ? fixUrl(eduPath) : '';
    prevFilePathRef.current = eduPath;
    const eduFileName = eduPath ? eduPath.split('/').pop() : '';
    setPreviewFileName(eduFileName);
    setEduFileName(eduFileName);
    setEduLocation(eduPath);
    setPreviewUrl(eduFixedUrl);
    setEduFile(null); // 서버에서 불러왔을 땐 로컬 업로드된 파일 초기화

    /** 비디오 파일 처리 */
    const videoPath = data[0].VIDEO_LOCATION || '';
    const videoFullUrl = videoPath ? getFullFileUrl(videoPath) : '';
    prevVideoPathRef.current = videoPath;
    setVideoUrl(videoFullUrl);
    setVideoFile(null); // 서버에서 불러왔을 땐 로컬 업로드된 파일 초기화
    setVideoLocation(videoPath);

    const videoFileName = videoPath ? videoPath.split('/').pop() : '';
    setVideoFileName(videoFileName);
  };

  const getFullFileUrl = (relativePath) => {
    if (!relativePath) return '';
    const fixedPath = fixUrl(relativePath);
    const fullUrl = `${Global.file.useUrl}files/${fixedPath}`;
    return fullUrl;
  };

  // 교육자료 파일 삭제
  const handleEduFileDelete = async () => {
    console.log(rowClickData.current, '교육파일삭제!!!!!!');
    // rowClickData 확인
    if (!rowClickData.current || !rowClickData.current.DEP_CD) {
      dispatch(
        showSnackbar({
          message: '부서 정보를 찾을 수 없습니다.',
          type: 'error',
        })
      );
      return;
    }

    const depCd = rowClickData.current.DEP_CD;

    // 파일삭제
    const oldFilePath = prevFilePathRef.current || '';

    if (oldFilePath) {
      await moveAndReplaceFile(oldFilePath, null, null, null);
    }

    // DB FILE 정보 UPDATE
    const deleteResult = await DeleteLogic1();

    console.log(deleteResult, 'deleteResult');

    if (deleteResult) {
      // 모달이 열려있으면 해당 부서의 파일 정보 다시 불러오기 (서버에서 최신 데이터 가져옴)
      if (modalToggle1) {
        // DB 업데이트 반영을 위해 약간의 지연
        await new Promise((resolve) => setTimeout(resolve, 100));
        await loadInitialFile(depCd);
        // 그리드 재조회 (모달 상태 유지)
        await SearchLogic1();
      } else {
        // 모달이 닫혀있으면 초기화만
        setPreviewFileName('');
        setPreviewUrl('');
        setEduFileName('');
        setEduLocation('');
        prevFilePathRef.current = '';
        // 그리드 재조회
        await SearchLogic1();
      }
    }
  };

  // URL 인코딩 처리
  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    const parts = url.split('/');
    const fileName = parts.pop();
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };

  //#region 조회
  //조회조건 부서 조회
  const SearchLogic1 = async (onComplete) => {
    // 모달이 열려있을 때는 모달 관련 상태를 유지
    ResetLogicAll(modalToggle1);
    dispatch(showLoading());
    try {
      // 시스템 계정일 경우 회사 검색조건으로 검색
      const coCd =
        userInfo.authCd === 'ADMIN'
          ? props.searchRef.current.coCd
          : userInfo.coCd;

      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TRA_BASIC_04_R1',
            _USER_ID: userInfo.userid || '', //로그인한 userInfo 사업장코드
            _AUTH_CD: Commons.EncryptAES(userInfo.authCd) || '', //권한코드
            _CO_CD: Commons.EncryptAES(coCd) || '', //권한코드
            _CUST_CD: Commons.EncryptAES(props.searchRef.current.custCd) || '', //사업장코드
            _searchText: Commons.EncryptAES('') || '', //검색창
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data.length === 0) {
          setRowData1([]);
          dispatch(
            showSnackbar({
              message: '데이터가 없습니다.',
              type: 'info',
            })
          );
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));

          return false;
        } else {
          setRowData1(Commons.InsertNumber(data));
          if (typeof onComplete === 'function') {
            onComplete(data);
          }
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };

  //#region 나머지 함수
  //인쇄 함수
  const PrintLogic1 = async () => {
    setLoading(true);

    let headerData = [];
    let tableData = [];

    try {
      headerData.push({
        safetyYear: dayjs(props.searchRef.current.searchYear).format('YYYY'),
      });
      tableData = rowData1;
      const printData = {
        FileName: 'TRA_BASIC_04',
        TableData: JSON.stringify(tableData),
        HeaderData: JSON.stringify(headerData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  const PopupClickEvent1 = async (e) => {
    rowClickData.current = e;

    //상태 초기화
    setVideoFile(null); // 비디오 파일
    setEduFile(null); // 교육자료 파일
    setPreviewFileName(''); // 교육자료 파일명
    setPreviewUrl(''); // 교육자료 미리보기 URL
    setVideoUrl(null); // 비디오 URL
    setVideoFileName(''); // 비디오 파일명
    setVideoLocation(''); // 비디오 서버 경로

    prevFilePathRef.current = ''; // 기존 파일 경로 참조값도 초기화
    prevVideoPathRef.current = '';

    await loadInitialFile(e.DEP_CD);
    //await SearchLogic2();
    setTimeout(() => setModalToggle1(true), 100);
  };

  const PopupClickEvent2 = async (e) => {
    setModalToggle3(true);

    // 교육자료 상태 초기화
    setEduFile(null);
    setEduFileName('');
    setEduLocation('');
    setPreviewUrl('');
    setPreviewFileName('');

    // 교육동영상 상태 초기화
    setVideoFile(null);
    setVideoFileName('');
    setVideoLocation('');
    setVideoUrl && setVideoUrl(''); // 서버에서 불러온 영상 경로도 있다면 초기화

    // 기타 필요 상태 초기화
    if (fileInputRef?.current) fileInputRef.current.value = '';
  };

  // 그리드 행 별 업로드 된 영상 삭제 (서버 및 DB)
  const handleVideoDelete = async () => {
    // rowClickData 확인
    if (!rowClickData.current || !rowClickData.current.DEP_CD) {
      dispatch(
        showSnackbar({
          message: '부서 정보를 찾을 수 없습니다.',
          type: 'error',
        })
      );
      return;
    }

    const depCd = rowClickData.current.DEP_CD;

    // 기존 파일삭제
    const oldFilePath = prevVideoPathRef.current || '';

    if (oldFilePath) {
      await moveAndReplaceFile(oldFilePath, null, null, null);
    }

    // DB FILE 정보 UPDATE
    const deleteResult = await DeleteLogic2();

    if (deleteResult) {
      // 모달이 열려있으면 해당 부서의 파일 정보 다시 불러오기 (서버에서 최신 데이터 가져옴)
      if (modalToggle1) {
        // DB 업데이트 반영을 위해 약간의 지연
        await new Promise((resolve) => setTimeout(resolve, 100));
        await loadInitialFile(depCd);
        // 그리드 재조회 (모달 상태 유지)
        await SearchLogic1();
      } else {
        // 모달이 닫혀있으면 초기화만
        setVideoFile(null);
        setVideoFileName('');
        setVideoLocation('');
        setVideoUrl('');
        prevVideoPathRef.current = '';
        // 그리드 재조회
        await SearchLogic1();
      }
    }
  };

  // 전체 비디오파일 업로드 시 값만 비워줌(추가버튼 클릭 시 팝업)
  const handleVideoDelete2 = () => {
    setVideoFile(null); // 업로드된 파일 객체 초기화
    setVideoFileName(''); // 파일명 초기화
    setVideoLocation(''); // 서버 경로 초기화
  };

  const handleEduFileDelete2 = async () => {
    // 기존 파일삭제
    const oldFilePath = prevFilePathRef.current || '';

    await moveAndReplaceFile(oldFilePath, null, null, null);
    setEduFile(null); // 업로드된 교육자료 파일 초기화
    setPreviewFileName(''); // 파일명 초기화
    setPreviewUrl(''); // 미리보기 URL 초기화
    setEduFileName(''); // 파일명 상태값 초기화 (필요시)
    setEduLocation(''); // 서버 경로 초기화 (필요시)
  };

  // 파일 확장자 추출 헬퍼
  const getExtension = (url) => {
    if (!url) return '';
    const name = url.split('/').pop();
    return name?.split('.').pop().toLowerCase() || '';
  };

  // 파일 선택 후 처리
  const moveAndReplaceFile = async (
    oldFilePath, // 기존 파일 경로 (이전 파일 위치, 없으면 빈 문자열)
    sourcePreviewPath, // 현재 파일 위치 (임시 경로 등, 미리보기 경로)
    newFileName, // 새로 저장할 파일명
    targetPath // 최종 저장할 디렉터리 경로 (예: Education/고객코드/부서코드/DEP_BASIC)
  ) => {
    try {
      const payload = {
        oldFilePath,
        sourcePreviewPath,
        newFileName,
        targetPath,
      };

      const { data } = await Commons.Axios(
        'post1',
        Global.file.useUrl + Global.urls.Execute.moveAndReplaceFile,
        payload
      );

      if (!data || data.type === 'Error') {
        throw new Error(data?.message || '파일 이동 실패');
      }

      return data; // 성공 시 서버 응답 반환 (true 등)
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e.message || '파일 저장 실패',
          type: 'error',
        })
      );
      console.error('moveAndReplaceFile Error:', e);
      return null; // 실패 시 null 반환
    }
  };

  const handleFileClick = () => {
    fileInputRef.current?.click();
  };

  // 서버에 파일 업로드 후 URL 얻기
  const uploadFileAndGetUrl = async (file) => {
    const ext = file.name.split('.').pop().toLowerCase();

    if (ext === 'pdf') {
      const arrayBuffer = await file.arrayBuffer();
      const pdfDoc = await PDFDocument.load(arrayBuffer);
      pdfDoc.setTitle(file.name);
      const modifiedBytes = await pdfDoc.save();
      const modifiedFile = new File(
        [new Blob([modifiedBytes], { type: 'application/pdf' })],
        file.name,
        { type: 'application/pdf' }
      );
      const filePath = await uploadFile(modifiedFile);
      if (!filePath) return null;
      prevFilePathRef.current = filePath;
      return fixUrl(filePath);
    } else {
      const filePath = await uploadFile(file);
      if (!filePath) return null;
      prevFilePathRef.current = filePath;
      return fixUrl(filePath);
    }
  };

  // 서버에 파일 업로드 후 URL 얻기
  const uploadFileAndGetUrl2 = async (file, depCd) => {
    const ext = file.name.split('.').pop().toLowerCase();

    let uploadedFilePath;

    if (ext === 'pdf') {
      const arrayBuffer = await file.arrayBuffer();
      const pdfDoc = await PDFDocument.load(arrayBuffer);
      pdfDoc.setTitle(file.name);
      const modifiedBytes = await pdfDoc.save();
      const modifiedFile = new File(
        [new Blob([modifiedBytes], { type: 'application/pdf' })],
        file.name,
        { type: 'application/pdf' }
      );
      uploadedFilePath = await uploadFile2(modifiedFile, depCd);
    } else {
      uploadedFilePath = await uploadFile2(file, depCd);
    }

    if (!uploadedFilePath) {
      return { path: '', url: '' };
    }

    const { path, url } = uploadedFilePath;

    prevFilePathRef.current = path;
    setEduFilePath(path);

    return {
      path: path,
      url: url || fixUrl(path), // ✅ HWP 변환된 PDF URL이 있으면 그걸 쓰고, 없으면 path로부터 생성
    };
  };

  // 실제 파일 업로드 API 호출
  const uploadFile = async (_file) => {
    setLoading(true);
    const targetRow = rowClickData.current;

    const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
    const filePath = `Education/${props.searchRef.current.custCd}/${targetRow.DEP_CD}/DEP_BASIC`;
    let finalSavePath = '';

    try {
      if (_file.size > MAX_CHUNK_UPLOAD_SIZE) {
        // 대용량 파일: 청크 업로드
        finalSavePath = await uploadInChunks(_file);
      } else {
        // 일반 파일 업로드
        const formData = new FormData();
        formData.append('UserId', userInfo.userid);
        formData.append('FilePath', filePath);
        formData.append('FormFile', _file);

        const res = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = res?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }

      const cleanedPath = finalSavePath
        .replace(/^.*\\Education/, 'Education')
        .replace(/\\/g, '/');

      // ✅ moveAndReplaceFile 호출
      const oldFilePath = prevFilePathRef.current || '';

      const deleted = await moveAndReplaceFile(
        oldFilePath,
        cleanedPath,
        _file.name,
        filePath
      );

      if (!deleted) return null;

      // DB 저장
      const saved = await saveEduFile(cleanedPath, _file.name);
      if (!saved) return null;

      // hwp 파일이면 pdf 변환 후 url 반환
      const ext = _file.name.split('.').pop()?.toLowerCase();
      if (ext === 'hwp') {
        const hwpUrl = await ConvertHwpToPdf(cleanedPath);
        return hwpUrl || null;
      }

      return cleanedPath;
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
      return null;
    } finally {
      setLoading(false);
    }
  };

  // 실제 파일 업로드 API 호출
  const uploadFile2 = async (_file, depCd) => {
    setLoading(true);

    const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
    const filePath = 'PreviewFiles';
    let finalSavePath = '';

    try {
      if (_file.size > MAX_CHUNK_UPLOAD_SIZE) {
        // 대용량 파일: 청크 업로드
        finalSavePath = await uploadInChunks(_file);
      } else {
        // 일반 파일 업로드
        const formData = new FormData();
        formData.append('UserId', userInfo.userid);
        formData.append('FilePath', filePath);
        formData.append('FormFile', _file);

        const res = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = res?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }

      const cleanedPath = finalSavePath
        .replace(/^.*\\PreviewFiles/, 'PreviewFiles')
        .replace(/\\/g, '/');

      prevFilePathRef.current = cleanedPath;

      // hwp 파일이면 pdf 변환 후 url 반환
      const ext = _file.name.split('.').pop()?.toLowerCase();

      // ✅ HWP 파일이면 변환된 PDF 경로(url)를 직접 반환
      if (ext === 'hwp') {
        const hwpUrl = await ConvertHwpToPdf(cleanedPath);

        setConvertedPdfPath(hwpUrl); // 임시 저장

        if (!hwpUrl) {
          dispatch(
            showSnackbar({ message: 'HWP 파일 PDF 변환 실패', type: 'error' })
          );
          return null;
        }

        // 여기서 반환되는 건 URL임
        return { path: cleanedPath, url: hwpUrl };
      }

      return { path: cleanedPath, url: null }; // 일반 파일은 path만

      // if (ext === 'hwp') {
      //   const hwpUrl = await ConvertHwpToPdf(cleanedPath);
      //   return hwpUrl || null;
      // }

      // return cleanedPath;
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
      return null;
    } finally {
      setLoading(false);
    }
  };

  // 교육동영상 저장
  const saveVideoFile = async (videoName, file) => {
    try {
      const targetRow = rowClickData.current;
      const saveData = [
        {
          procedureName: 'SP_TRA_BASIC_04_U1',
          _DEP_CD: Commons.EncryptAES(targetRow.DEP_CD) || '',
          _VIDEO_LOCATION:
            Commons.EncryptAES(
              `Video/${props.searchRef.current.custCd}/${targetRow.DEP_CD}/DEP_BASIC/${videoName}`
            ) || '',
          _VIDEO_FILE_NAME: Commons.EncryptAES(videoName) || '',
          _USER_ID: userInfo.userid || '',
        },
      ];
      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        saveData
      );

      const data = result.data;

      if (data.length === 0 || data[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: data[0]?.message || '저장 중 에러가 발생했습니다.',
            type: 'error',
          })
        );
        return false;
      } else {
        dispatch(
          showSnackbar({
            message: '저장되었습니다.',
            type: 'success',
          })
        );

        await SaveLogic2(
          `Video/${props.searchRef.current.custCd}/${targetRow.DEP_CD}/DEP_BASIC`,
          file
        );

        return true;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error.message,
          type: 'error',
        })
      );
      return false;
    } finally {
      // setLoading(false);
    }
  };

  // 동영상파일 파일서버에 저장
  const SaveLogic2 = async (_value1, _value2, oldFullPath) => {
    // 기존파일 삭제
    try {
      if (oldFullPath) {
        await moveAndReplaceFile(oldFullPath, null, null, null);
      }
      const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
      let finalSavePath = '';

      // ✅ 대용량 파일: 청크 업로드
      if (_value2.size > MAX_CHUNK_UPLOAD_SIZE) {
        finalSavePath = await uploadInChunks(_value1, _value2);
      }
      // ✅ 일반 파일 업로드
      else {
        const formData = new FormData();

        formData.append('UserId', userInfo.userid);
        formData.append('FilePath', _value1);
        formData.append('FormFile', _value2);

        const res = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = res?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '동영상파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      throw e; // ✅ 에러를 상위로 전파
    } finally {
    }
  };

  // 교육자료파일 파일서버에 저장
  const SaveLogic3 = async (_value1, _value2, oldFullPath) => {
    try {
      // 기존파일삭제
      if (oldFullPath) {
        await moveAndReplaceFile(oldFullPath, null, null, null);
      }

      const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
      let finalSavePath = '';

      // ✅ 대용량 파일: 청크 업로드
      if (_value2.size > MAX_CHUNK_UPLOAD_SIZE) {
        finalSavePath = await uploadInChunks(_value1, _value2);
      }
      // ✅ 일반 파일 업로드
      else {
        const formData = new FormData();

        formData.append('UserId', userInfo.userid);
        formData.append('FilePath', _value1);
        formData.append('FormFile', _value2);

        const res = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = res?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }

      const savePath = finalSavePath.replace(/\\/g, '/');

      // HWP면 저장 경로에서 PDF 변환 요청 ( moveAndReplaceFile 함수를 사용할 경우 옮기는 과정에서 파일이 깨짐. 폴더에 직접변환처리)
      const ext = _value2.name.split('.').pop()?.toLowerCase();
      if (ext === 'hwp') {
        const convertedUrl = await ConvertHwpToPdf(savePath); // 실제 저장된 위치에서 변환!!!

        if (!convertedUrl) {
          dispatch(
            showSnackbar({ message: 'HWP → PDF 변환 실패', type: 'error' })
          );
          return savePath;
        }

        // 성공 시 PDF도 저장되었음
        // dispatch(showSnackbar({ message: 'HWP → PDF 변환 완료', type: 'success' }));
      }

      return savePath;
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      throw e; // ✅ 에러를 상위로 전파
    } finally {
    }
  };

  // 교육자료 저장
  const saveEduFile = async (filePath, fileName) => {
    // setLoading(true);

    try {
      const targetRow = rowClickData.current;
      const saveData = [
        {
          procedureName: 'SP_TRA_BASIC_04_U2',
          _DEP_CD: Commons.EncryptAES(targetRow.DEP_CD) || '',
          _EDU_LOCATION:
            Commons.EncryptAES(
              `Education/${props.searchRef.current.custCd}/${targetRow.DEP_CD}/DEP_BASIC/${fileName}`
            ) || '',
          _EDU_FILE_NAME: Commons.EncryptAES(fileName) || '',
          _USER_ID: userInfo.userid || '',
        },
      ];
      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        saveData
      );

      const data = result.data;

      if (data.length === 0 || data[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: data[0]?.message || '저장 중 에러가 발생했습니다.',
            type: 'error',
          })
        );
        return false;
      } else {
        //await SearchLogic1();
        dispatch(
          showSnackbar({
            message: '저장되었습니다.',
            type: 'success',
          })
        );
        return true;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error.message,
          type: 'error',
        })
      );
      return false;
    } finally {
      // setLoading(false);
    }
  };

  // 교육자료 저장
  const saveEduFile2 = async (filePath, fileName) => {
    // setLoading(true);

    try {
      const targetRow = rowClickData.current;
      const saveData = [
        {
          procedureName: 'SP_TRA_BASIC_04_U2',
          _DEP_CD: Commons.EncryptAES(targetRow.DEP_CD) || '',
          _EDU_LOCATION:
            Commons.EncryptAES(
              `Education/${props.searchRef.current.custCd}/temp/DEP_BASIC/${fileName}`
            ) || '',
          _EDU_FILE_NAME: Commons.EncryptAES(fileName) || '',
          _USER_ID: userInfo.userid || '',
        },
      ];
      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        saveData
      );

      const data = result.data;

      if (data.length === 0 || data[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: data[0]?.message || '저장 중 에러가 발생했습니다.',
            type: 'error',
          })
        );
        return false;
      } else {
        await SearchLogic1();
        dispatch(
          showSnackbar({
            message: '저장되었습니다.',
            type: 'success',
          })
        );
        return true;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error.message,
          type: 'error',
        })
      );
      return false;
    } finally {
      // setLoading(false);
    }
  };

  // DB에 파일 경로 및 이름 저장
  const saveFileInfo = async (filePath, fileName) => {
    // setLoading(true);
    try {
      const targetRow = rowClickData.current;
      const saveData = [
        {
          procedureName: 'SP_TRA_BASIC_04_U1',
          _DEP_CD: Commons.EncryptAES(targetRow.DEP_CD) || '',
          _VIDEO_LOCATION: Commons.EncryptAES() || '',
          _VIDEO_FILE_NAME: Commons.EncryptAES() || '',
          _EDU_LOCATION: Commons.EncryptAES() || '',
          _EDU_FILE_NAME: Commons.EncryptAES() || '',
          _USER_ID: userInfo.userid || '',
        },
      ];
      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        saveData
      );

      const data = result.data;

      if (data.length === 0 || data[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: data[0]?.message || '저장 중 에러가 발생했습니다.',
            type: 'error',
          })
        );
        return false;
      } else {
        dispatch(
          showSnackbar({
            message: '저장되었습니다.',
            type: 'success',
          })
        );
        return true;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error.message,
          type: 'error',
        })
      );
      return false;
    } finally {
      // setLoading(false);
    }
  };

  // DB에 파일 경로 및 이름 저장 - *(filePath, fileName이 없기 떄문에, 빈값으로 UPDATE 됨)
  const DeleteLogic1 = async (filePath, fileName) => {
    // setLoading(true);
    try {
      const targetRow = rowClickData.current;
      console.log(targetRow);

      if (!targetRow || !targetRow.DEP_CD) {
        dispatch(
          showSnackbar({
            message: '부서 정보를 찾을 수 없습니다.',
            type: 'error',
          })
        );
        return false;
      }

      const saveData = [
        {
          procedureName: 'SP_TRA_BASIC_04_D1',
          _DEP_CD: Commons.EncryptAES(targetRow.DEP_CD) || '',
          _EDU_LOCATION: Commons.EncryptAES('') || '',
          _EDU_FILE_NAME: Commons.EncryptAES('') || '',
          _USER_ID: userInfo.userid || '',
        },
      ];
      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        saveData
      );

      const data = result.data;

      if (data.length === 0 || data[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: data[0]?.message || '저장 중 에러가 발생했습니다.',
            type: 'error',
          })
        );
        return false;
      } else {
        dispatch(
          showSnackbar({
            message: '교육자료가 삭제되었습니다.',
            type: 'success',
          })
        );
        return true;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error.message || '삭제 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return false;
    } finally {
      // setLoading(false);
    }
  };

  // DB에 파일 경로 및 이름 저장 - *(filePath, fileName이 없기 떄문에, 빈값으로 UPDATE 됨)
  const DeleteLogic2 = async (filePath, fileName) => {
    // setLoading(true);
    try {
      const targetRow = rowClickData.current;

      if (!targetRow || !targetRow.DEP_CD) {
        dispatch(
          showSnackbar({
            message: '부서 정보를 찾을 수 없습니다.',
            type: 'error',
          })
        );
        return false;
      }

      const saveData = [
        {
          procedureName: 'SP_TRA_BASIC_04_D2',
          _DEP_CD: Commons.EncryptAES(targetRow.DEP_CD) || '',
          _VIDEO_LOCATION: Commons.EncryptAES('') || '',
          _VIDEO_FILE_NAME: Commons.EncryptAES('') || '',
          _USER_ID: userInfo.userid || '',
        },
      ];
      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        saveData
      );

      const data = result.data;

      if (data.length === 0 || data[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: data[0]?.message || '저장 중 에러가 발생했습니다.',
            type: 'error',
          })
        );
        return false;
      } else {
        dispatch(
          showSnackbar({
            message: '교육 동영상이 삭제되었습니다.',
            type: 'success',
          })
        );
        return true;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error.message || '삭제 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return false;
    } finally {
      // setLoading(false);
    }
  };

  // 미리보기 렌더 함수 (previewUrl 기반)
  const renderPreview = () => {
    if (!previewUrl) return <div>미리보기 영역</div>;

    const ext = getExtension(previewUrl);
    const fullUrl = Global.file.useUrl + 'files/' + previewUrl;

    if (['png', 'jpg', 'jpeg'].includes(ext)) {
      return (
        <img
          src={fullUrl}
          alt="미리보기"
          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
        />
      );
    }

    if (ext === 'pdf' || ext === 'hwp') {
      const pdfUrl =
        ext === 'hwp' ? fullUrl.replace(/\.hwp$/i, '.pdf') : fullUrl;

      return (
        <iframe
          src={pdfUrl}
          width="100%"
          height="600px"
          title="PDF 미리보기"
          allow="fullscreen"
        />
      );
    }

    if (['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)) {
      const docs = [{ uri: fullUrl, fileType: ext }];
      return (
        <DocViewer
          documents={docs}
          pluginRenderers={DocViewerRenderers}
          style={{ width: '100%', height: '100%' }}
        />
      );
    }

    return <div>지원하지 않는 형식입니다.</div>;
  };

  // 미리보기 파일 저장 - GridFileUploadF 공통 함수에서 사용
  const SaveLogicPreview = async (_file) => {
    setLoading(true);

    const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
    const filePath = 'PreviewFiles';
    let finalSavePath = '';

    try {
      // 대용량 파일: 청크 업로드
      if (_file.size > MAX_CHUNK_UPLOAD_SIZE) {
        finalSavePath = await uploadInChunks(_file);
      }
      // 일반 파일 업로드
      else {
        let formList = new FormData();
        formList.append('UserId', userInfo.userid);
        formList.append('FilePath', filePath); // 저장 경로
        formList.append('FormFile', _file); // 파일

        const result = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formList
        );

        finalSavePath = result?.data?.filePath || '';
      }

      // 후처리: 저장 경로 정리 및 HWP 변환
      if (finalSavePath) {
        const savePath = finalSavePath
          .replace(/^.*\\PreviewFiles/, 'PreviewFiles')
          .replace(/\\/g, '/');

        const ext = _file.name.split('.').pop()?.toLowerCase();
        if (ext === 'hwp') {
          const hwpUrl = await ConvertHwpToPdf(savePath);
          return hwpUrl || null;
        }

        return savePath;
      } else {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }
    } catch (e) {
      console.error('Error in SaveLogicPreview:', e);
      dispatch(
        showSnackbar({
          message: '파일 업로드 중 오류 발생',
          type: 'error',
        })
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  const uploadInChunks = async (
    filePath,
    file,
    chunkSize = 5 * 1024 * 1024
  ) => {
    const totalChunks = Math.ceil(file.size / chunkSize);
    const saveName = file.name;

    for (let i = 0; i < totalChunks; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);

      const formData = new FormData();
      formData.append('chunk', chunk);
      formData.append('chunkIndex', i);
      formData.append('totalChunks', totalChunks);
      formData.append('fileName', saveName);
      formData.append('UserId', userInfo.userid);
      formData.append('FilePath', filePath);

      await Commons.Axios(
        'chunk',
        Global.file.useUrl + Global.urls.Execute.UploadChunk,
        null,
        formData
      );
    }

    // 병합 요청
    const mergeResponse = await Commons.Axios(
      'post',
      Global.file.useUrl + Global.urls.Execute.MergeChunks,
      null, // 쿼리스트링 없음
      {
        fileName: saveName,
        filePath,
        userId: userInfo.userid,
      }
    );

    return mergeResponse?.data?.filePath || '';
  };

  // HWP -> PDF 변환
  const ConvertHwpToPdf = async (_filePath) => {
    if (!_filePath) {
      return null;
    }

    try {
      const payload = { FilePath: _filePath };

      const response = await Commons.Axios(
        'post1',
        Global.file.useUrl + Global.urls.Execute.ConvertHwpToPdf,
        payload
      );

      // 서버 응답 검증
      if (response?.data?.url) {
        return response.data.url;
        // 서버가 '/PreviewFiles/xxx.pdf' 형태로 반환하면 'files/PreviewFiles/xxx.pdf'
      } else {
        console.error('ConvertHwpToPdf: 서버 응답이 유효하지 않음', response);
        return null;
      }
    } catch (error) {
      console.error('ConvertHwpToPdf: 요청 중 오류 발생', error);
      return null;
    }
  };

  // 다운로드 기능
  const DownloadLogic1 = async (e) => {
    rowClickData.current = e;
    const targetRow = rowClickData.current;

    if (!targetRow || !targetRow.EDU_LOCATION) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const fileUrl = targetRow.EDU_LOCATION;
      const fileName =
        decodeURIComponent(fileUrl.split('/').pop()) || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: fileUrl,
      };

      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      );

      const contentType = result?.headers?.['content-type'];
      const blobData = result?.data;

      if (!blobData || !contentType) {
        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
            type: 'error',
          })
        );
        return;
      }

      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch(
        showSnackbar({
          message: `"${fileName}" 다운로드 완료`,
          type: 'success',
        })
      );
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
    }
  };

  //  교육도영상 다운로드 기능
  const DownloadLogic2 = async (e) => {
    rowClickData.current = e;
    const targetRow = rowClickData.current;

    if (!targetRow || !targetRow.VIDEO_LOCATION) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const fileUrl = targetRow.VIDEO_LOCATION;
      const fileName =
        decodeURIComponent(fileUrl.split('/').pop()) || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: fileUrl,
      };

      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      );

      const contentType = result?.headers?.['content-type'];
      const blobData = result?.data;

      if (!blobData || !contentType) {
        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
            type: 'error',
          })
        );
        return;
      }

      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch(
        showSnackbar({
          message: `"${fileName}" 다운로드 완료`,
          type: 'success',
        })
      );
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
    }
  };

  const ResetLogicAll = (keepModalState = false) => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setSelectedModalRowData2([]);
    setChangedModalRowData2([]);
    setConvertedPdfPath('');

    // 모달이 열려있을 때는 모달 관련 상태를 초기화하지 않음
    if (!keepModalState) {
      rowClickData.current = '';
      setFile(null);
      setPreviewUrl(null);
      setPreviewFileName('');
      fileInputRef.current = null;
      prevFilePathRef.current = '';
      prevVideoPathRef.current = '';
      setVideoFile(null);
      setVideoUrl(null);
      setVideoLocation('');
      setVideoFileName('');
      setEduFile(null);
      setEduLocation('');
      setEduFileName('');
      setEduFilePath('');
    }
    setDepartmentList([]);
    setSelectedBonbu([]);
    setSelectedBuseo([]);
    setSelectedTeam([]);
    setSelectedPart([]);
    setBonbuList([]);
    setBuseoList([]);
    setTeamList([]);
    setPartList([]);
  };

  //#endregion

  return (
    <div className="wrap">
      <TRA_BASIC_02
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        showSnackbar={showSnackbar}
        dispatch={dispatch}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        modalToggle2={modalToggle2}
        setModalToggle2={setModalToggle2}
        modalRowData2={modalRowData2}
        setModalRowData2={setModalRowData2}
        selectedModalRowData2={selectedModalRowData2}
        setSelectedModalRowData2={setSelectedModalRowData2}
        changedModalRowData2={changedModalRowData2}
        setChangedModalRowData2={setChangedModalRowData2}
        modalToggle3={modalToggle3}
        setModalToggle3={setModalToggle3}
        searchRef={props.searchRef}
        filterClick4={props.filterClick4}
        setFilterClick4={props.setFilterClick4}
        searchClick4={props.searchClick4}
        setSearchClick4={props.setSearchClick4}
        addClick4={props.addClick4}
        setAddClick4={props.setAddClick4}
        saveClick4={props.saveClick4}
        setSaveClick4={props.setSaveClick4}
        deleteClick4={props.deleteClick4}
        setDeleteClick4={props.setDeleteClick4}
        printClick4={props.printClick4}
        setPrintClick4={props.setPrintClick4}
        setFile={setFile}
        fileInputRef={fileInputRef}
        PopupClickEvent1={PopupClickEvent1}
        PopupClickEvent2={PopupClickEvent2}
        rowClickData={rowClickData}
        open={modalToggle2}
        setOpen={setModalToggle2}
        videoFile={videoFile}
        setVideoFile={setVideoFile}
        videoLocation={videoLocation}
        setVideoLocation={setVideoLocation}
        videoFileName={videoFileName}
        setVideoFileName={setVideoFileName}
        videoUrl={videoUrl}
        setVideoUrl={setVideoUrl}
        eduFile={eduFile}
        setEduFile={setEduFile}
        eduLocation={eduLocation}
        setEduLocation={setEduLocation}
        eduFileName={eduFileName}
        setEduFileName={setEduFileName}
        eduFilePath={eduFilePath}
        setEduFilePath={setEduFilePath}
        previewUrl={previewUrl}
        setPreviewUrl={setPreviewUrl}
        previewFileName={previewFileName}
        setPreviewFileName={setPreviewFileName}
        bonbuList={bonbuList}
        setBonbuList={setBonbuList}
        selectedBonbu={selectedBonbu}
        setSelectedBonbu={setSelectedBonbu}
        buseoList={buseoList}
        setBuseoList={setBuseoList}
        selectedBuseo={selectedBuseo}
        setSelectedBuseo={setSelectedBuseo}
        teamList={teamList}
        setTeamList={setTeamList}
        selectedTeam={selectedTeam}
        setSelectedTeam={setSelectedTeam}
        partList={partList}
        setPartList={setPartList}
        selectedPart={selectedPart}
        setSelectedPart={setSelectedPart}
        // 함수
        validateSelection={props.validateSelection}
        ResetLogicAll={ResetLogicAll}
        SearchLogic1={SearchLogic1}
        SaveLogic2={SaveLogic2}
        SaveLogic3={SaveLogic3}
        PrintLogic1={PrintLogic1}
        DeleteLogic1={DeleteLogic1}
        DeleteLogic2={DeleteLogic2}
        SaveLogicPreview={SaveLogicPreview}
        DownloadLogic1={DownloadLogic1}
        DownloadLogic2={DownloadLogic2}
        handleSave={handleSave}
        fetchDepartmentData={fetchDepartmentData}
        uploadFileAndGetUrl={uploadFileAndGetUrl}
        uploadFileAndGetUrl2={uploadFileAndGetUrl2}
        saveFileInfo={saveFileInfo}
        saveVideoFile={saveVideoFile}
        getExtension={getExtension}
        renderPreview={renderPreview}
        handleVideoChange={handleVideoChange}
        handleVideoChange2={handleVideoChange2}
        handleVideoDelete={handleVideoDelete}
        handleVideoDelete2={handleVideoDelete2}
        handleEduFileChange={handleEduFileChange}
        handleEduFileChange2={handleEduFileChange2}
        handleEduFileDelete={handleEduFileDelete}
        handleEduFileDelete2={handleEduFileDelete2}
        saveEduFile={saveEduFile}
        saveEduFile2={saveEduFile2}
        handleBonbuSelect={handleBonbuSelect}
        handleBuseoSelect={handleBuseoSelect}
        handleTeamSelect={handleTeamSelect}
        renderCheckboxList={renderCheckboxList}
        // handleBuseoChange={handleBuseoChange}
        // handleTeamChange={handleTeamChange}
        // handlePartChange={handlePartChange}
        toggleSelection={toggleSelection}
        getFilteredSelectedItems={getFilteredSelectedItems}
        getDepLevel={getDepLevel}
      />
      <Loading open={loading} />
    </div>
  );
}

export default TRA_BASIC_02F;
